
import {EXPLORE_MODE, PAPAYA_SLICES} from '../../symbols/papaya.symbols';

export class SetActiveExploreMode {
  static readonly type = '[MainDashboard] Set Active Explore Mode';
  constructor(public exploreMode: EXPLORE_MODE) {}
}

export class SetActivePapayaViewMode {
  static readonly type = '[MainDashboard] Set Active Papaya View Mode';
  constructor(public viewMode: PAPAYA_SLICES) {}
}
